import dynamic from 'next/dynamic';
import { useEffect, useRef } from 'react';

import FlatLayout from 'components/Layout/FlatLayout';

import { sendSupixEvent } from 'lib/supix';
import { scrollToElement } from 'lib/utils';

import Faq from './Faq';
import Head from './Head';
import Hero from './Hero';

const ProgressGameBarDesk = dynamic(() => import('./ProgressGameBarDesk'), {
  ssr: false,
});

const MyBlackFridayPage = () => {
  const faqBlackFridayRef = useRef(null);

  useEffect(() => {
    sendSupixEvent('/car', { category: 100010000 });
  }, []);

  const onHandleScrollToFaq = () => {
    if (faqBlackFridayRef.current) {
      const faqElement = faqBlackFridayRef.current;
      const offsetTop = faqElement.offsetTop;

      scrollToElement(offsetTop);
    }
  };

  return (
    <>
      <Head />
      <FlatLayout.Margin>
        <FlatLayout.Body className="px-4 lg:px-0">
          <section className="flex items-center lg:min-h-[calc(100vh_-_16rem)]">
            <div className="flex w-full flex-col items-center gap-8">
              <Hero onClick={onHandleScrollToFaq} />
              {/*
                This component is highly dependent of browser APIs
                and needs to be forced to render only on client side.
              */}
              <ProgressGameBarDesk />
            </div>
          </section>
          <section ref={faqBlackFridayRef} className="mt-20">
            <Faq />
          </section>
        </FlatLayout.Body>
      </FlatLayout.Margin>
    </>
  );
};

export default MyBlackFridayPage;
